module.exports = __webpack_public_path__ + "c130aa136dff09edd54da3bee2e520f5.jpg";